import axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';

import UserAvatar from '../components/UserAvatar.vue';
import ReportButton from '../components/ReportButton.vue';
import { installSessionExpiryInterceptor } from '../utils/sessionExpiry';
import AccountApp from './components/AccountApp.vue';
import { createAccountRouter } from './router';

Vue.use(VueRouter);
Vue.component('user-avatar', UserAvatar);
Vue.component('report-button', ReportButton);

// Use the current page token, as the main app does, rather than relying only
// on an XSRF cookie that a late pre-login response may have replaced.
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
if (csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

const accountBootstrap = window.__ACCOUNT_BOOTSTRAP__ || {};
installSessionExpiryInterceptor(axios, {
    runtime: window,
    document,
    startedAuthenticated: Boolean(window.isAuthenticated || accountBootstrap.viewer),
});

const mountEl = document.getElementById('account-app');
if (mountEl) {
    const router = createAccountRouter();

    new Vue({
        router,
        render: (h) => h(AccountApp),
    }).$mount('#account-app');
}
